export const fuelTypes = [
    "Petrol",
    "Diesel",
    "Electric",
    "Hybrid",
    "LPG",
    "CNG",
    "Other",
];

export const transmissionTypes = [
    "Manual",
    "Automatic",
    "Semi-Automatic",
    "CVT",
    "Other",
];

export const registrationTypes = [
    "Individual",
    "Corporate",
    "Tourist",
];

export const inventoryTypes = [
    "Invested",
    "Parked",
    "Dealer's Stock",
];

